import { render, staticRenderFns } from "./Wap_YSY001_Step3.vue?vue&type=template&id=cf2c3f9e&scoped=true&"
import script from "./Wap_YSY001_Step3.vue?vue&type=script&lang=js&"
export * from "./Wap_YSY001_Step3.vue?vue&type=script&lang=js&"
import style0 from "./Wap_YSY001_Step3.vue?vue&type=style&index=0&id=cf2c3f9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2c3f9e",
  null
  
)

export default component.exports